var vms = vms || {};
vms.nav = vms.nav || {};

vms.nav.switch = function (pId, pLink, pNoConfirm) {
    var lConfirm = true;
    if (pLink && pNoConfirm == undefined)
        lConfirm = confirm(apex.lang.getMessage("JS15"));
    
    if (lConfirm){
        vms.load.add();
        apex.server.process("switchProfile", {
                x01: pId
            },{dataType: 'json'})
            .then(function (data) {
                if (data.err) {
                    vms.info.msg(data.err);
                    vms.load.remove();
                } else if (pLink) vms.nav.redirect(pLink);
                else if (data.url) vms.nav.redirect(data.url);
                else location.reload();
            })
            .catch(function (err) {
                console.log(err);
                vms.load.remove();
            });
    }
    /*$s("P0_PROFILE_ID_SWITCH", pId);
    if (pLink) $s("P0_SWITCH_LINK", pLink);
    if (pLink && pNoConfirm == undefined) {
        apex.confirm(apex.lang.getMessage("JS15"), 'SWITCH_PROFILE');
    } else {
        vms.load.add(null, true);
        setTimeout(function () {
            apex.submit("SWITCH_PROFILE");
        }, 1);
    }*/
};

vms.nav.redirect = function (pUrl){
    apex.navigation.redirect(pUrl);
};

vms.nav.vesselstatus = function (){
    var months = new Array("January", "February", "March",
        "April", "May", "June", "July", "August", "September",
        "October", "November", "December");
    var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    var d = new Date();
    var curr_date = d.getDate();
    var curr_month = d.getMonth();
    var curr_day = d.getDay();
    var curr_year = d.getFullYear();
    if ($("#t_Button_navControl").attr("aria-expanded") == 'true') {
       
        //$("#uiVesselStatus").html('<div class="ui-today-dy">' + days[curr_day].charAt(0).toUpperCase() + days[curr_day].slice(1) + '</div>' + '<div class="ui-today-dt">' + curr_date + '</div>' + '<div class="ui-today-mn" >' + months[curr_month] + ' ' + curr_year + '</div>');
 
        $("#uiVesselStatus").append('<div class="ui-vslstat stsB-' + $v('P0_VESSEL_STATUS_CODE') +'">Status: ' + $v('P0_VESSEL_STATUS') +'</div>');
        $("#uiVesselStatus").append('<div class="ui-vslplan">' + $v('P0_VESSEL_ACTIVE_TRIP') + ' </div>');
        //$("#uiVesselStatus").append('<div class="ui-vslplan">' + $v('P0_VESSEL_SYNC') + ' </div>');

        //$("#uiVesselSync").append('<div class="ui-vslsync">' + $v('P0_VESSEL_SYNC') + '</div>');
        //$("#uiVesselSync").append('<div class="ui-vslsyncbtn">' + $v('P0_VESSEL_SYNC_BTN') + ' </div>');	
	
        
    } else {
        $('#uiVesselStatus > div').remove();
        $('#t_TreeNav').css({"top":"0px","height":"auto"});
    }
}
